import { List } from 'immutable';
import { composeStateMachine } from '../module';
import { composeInitialState } from '../../composeActions';
export var effectInitialState = composeInitialState({
  queued: List()
});
export var effectState = composeStateMachine('effects', effectInitialState, function (compose) {
  return {
    queueEffect: compose.action(function (state, effect) {
      return state.update('queued', function (queued) {
        return queued.push(effect);
      });
    }),
    removeFromQueue: compose.action(function (state, effects) {
      return state.update('queued', function (queued) {
        return queued.filter(function (eff) {
          return effects.indexOf(eff) === -1;
        });
      });
    })
  };
});
var effectActions = effectState.actions,
    effectActionCreators = effectState.actionCreators,
    effectSelector = effectState.selector,
    effectBranchKey = effectState.branchKey,
    effectReducer = effectState.reducer;
export { effectActions, effectActionCreators, effectSelector, effectBranchKey, effectReducer };